module.exports = __webpack_public_path__ + "static/media/star.6c76a1e5.svg";